import axios from 'axios';

export const API_URL = process.env.REACT_APP_URL + '897623u9jkjdsjkdjsk/';

class ApiService {
  getCategories(access_token) {
    return axios
      .get(API_URL + 'categories', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postCategory(access_token, formData) {
    return axios
      .post(API_URL + 'categories', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updateCategory(access_token, formData) {
    return axios
      .put(API_URL + 'categories', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteCategory(access_token, id) {
    return axios
      .delete(API_URL + 'categories/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getProducts(access_token) {
    return axios
      .get(API_URL + 'products', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getProductDetails(access_token, id) {
    return axios
      .get(API_URL + 'products/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteProduct(access_token, id) {
    return axios
      .delete(API_URL + 'products/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postProduct(access_token, formData) {
    return axios
      .post(API_URL + 'products', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updateProduct(access_token, formData) {
    return axios
      .put(API_URL + 'products', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postUser(access_token, formData) {
    return axios
      .post(API_URL + 'users', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putUser(access_token, formData) {
    return axios
      .put(API_URL + 'users', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getUsers(access_token) {
    return axios
      .get(API_URL + 'users ', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getUserStats(access_token) {
    return axios
      .get(API_URL + 'users/stats', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getConfirmUsers(access_token) {
    return axios
      .get(API_URL + 'users/state/1', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getBloquedUsers(access_token) {
    return axios
      .get(API_URL + 'users-blocked', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getPendingUsers(access_token) {
    return axios
      .get(API_URL + 'users/state/2', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getUserDetails(access_token, id) {
    return axios
      .get(API_URL + 'users/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteUser(access_token, id) {
    return axios
      .delete(API_URL + 'users/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getDisttricts(access_token) {
    return axios
      .get(API_URL + 'districts', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getUserAddress(addressId, access_token) {
    return axios
      .get(API_URL + `user_address/${addressId}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }



  placesAutocomplete(access_token, query) {
    return axios
      .get(API_URL + 'user_address/places-autocomplete', {
        params: { query },
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((r) => r.data.suggestions || [])
      .catch(() => []);
  }

  placeDetails(access_token, place_id) {
    return axios
      .get(API_URL + 'user_address/place-details', {
        params: { place_id },
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((r) => r.data)
      .catch(() => null);
  }

  async addAddress(access_token, data) {
    return axios.post(API_URL + 'user_address', data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 422,
    });
  }

  async updateAddress(access_token, addressId, data) {
    return axios.put(API_URL + `user_address/${addressId}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 422,
    });
  }

  getOrders(access_token) {
    return axios
      .get(API_URL + 'purchase', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getOrdersToday(access_token) {
    return axios
      .get(API_URL + 'purchase_today', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postAceptPurchase(access_token, data) {
    return axios
      .post(API_URL + 'purchase/approve ', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postCancelPurchase(access_token, data) {
    return axios
      .post(API_URL + 'purchase/cancel', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postRemovePurchase(access_token, data) {
    return axios
      .post(API_URL + 'purchase/remove', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getOrderDetails(access_token, id) {
    return axios
      .get(API_URL + 'purchase/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postStateUser(access_token, data) {
    return axios
      .post(API_URL + 'users/state', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getSchedules(access_token) {
    return axios
      .get(API_URL + 'schedules', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getPickupWindow(access_token, id) {
    return axios
      .get(API_URL + 'pickup-windows/' + id + '/0', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postPickupWindow(access_token, data) {
    return axios
      .post(API_URL + 'pickup-windows', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putPickupWindow(access_token, data) {
    return axios
      .put(API_URL + 'pickup-windows', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deletePickupWindow(access_token, id) {
    return axios
      .delete(API_URL + 'pickup-windows/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updateStatusPickupWindow(access_token, id) {
    return axios
      .get(API_URL + 'pickup-windows-status/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // ========== CIERRES DE VENTANAS POR FECHA ==========

  // Obtener cierres de una ventana específica
  getPickupWindowClosures(access_token, windowId) {
    return axios
      .get(API_URL + 'pickup-windows/' + windowId + '/closures', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Obtener todos los cierres futuros
  getFutureClosures(access_token) {
    return axios
      .get(API_URL + 'pickup-window-closures/future', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Crear cierre de ventana
  createPickupWindowClosure(access_token, data) {
    return axios
      .post(API_URL + 'pickup-window-closures', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Eliminar cierre (reabrir ventana)
  deletePickupWindowClosure(access_token, closureId) {
    return axios
      .delete(API_URL + 'pickup-window-closures/' + closureId, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Obtener ventanas con conteo de cierres (para badges)
  getPickupWindowsWithClosuresCount(access_token, scheduleId) {
    return axios
      .get(API_URL + 'pickup-windows-closures-count/' + scheduleId, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getSchedulesDetails(access_token, id) {
    return axios
      .get(API_URL + 'site_hours/' + id + '/0', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postSchedulesDetails(access_token, data) {
    return axios
      .post(API_URL + 'site_hours', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putSchedulesDetails(access_token, data) {
    return axios
      .put(API_URL + 'site_hours', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteSchedulesDetails(access_token, id) {
    return axios
      .delete(API_URL + 'site_hours/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getCashUser(access_token, id) {
    return axios
      .get(API_URL + 'internal_accounts/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getAddressUser(access_token, id) {
    return axios
      .get(API_URL + 'addresses/ambassador/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putAddresssDeliveryUser(access_token, data) {
    return axios
      .put(API_URL + 'addresses/delivery', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postCashUser(access_token, data) {
    return axios
      .post(API_URL + 'internal_accounts', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getUserChangeRequest(access_token) {
    return axios
      .get(API_URL + 'users/refered-temporal', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putChangeUserRequest(access_token, data) {
    return axios
      .put(API_URL + 'users/refered-temporal', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getAddressChangeRequest(access_token) {
    return axios
      .get(API_URL + 'addresses/temporal', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putChangeAddressRequest(access_token, data) {
    return axios
      .put(API_URL + 'addresses/temporal/admin', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getChildProd(access_token, id) {
    return axios
      .get(API_URL + 'products/child/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putChildProd(access_token, data) {
    return axios
      .put(API_URL + 'products/child', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteChildProd(access_token, id) {
    return axios
      .delete(API_URL + 'products/child/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postChildProd(access_token, data) {
    return axios
      .post(API_URL + 'products/child', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getProductStock(access_token) {
    return axios
      .get(API_URL + 'products_stock', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postProductStock(access_token, data) {
    return axios
      .post(API_URL + 'products_stock', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postUserImport(access_token, formData) {
    return axios
      .post(API_URL + 'users/import', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getPurchaseCharge(access_token) {
    return axios
      .get(API_URL + 'purchase_charge', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postStatusDelivery(access_token, data) {
    return axios
      .post(API_URL + 'purchase/status_delivery', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getDataPurchaseCharge(access_token, id) {
    return axios
      .get(API_URL + 'purchase/charges/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updatePurchaseStatusCharge(access_token, formData) {
    return axios
      .post(API_URL + '_purchase/update/status_charge', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postPurchaseCharge(access_token, formData) {
    return axios
      .post(API_URL + "purchase/charges", formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  async updatePurchaseCharge(access_token, id, data) {
    const response = await axios.put(
      `${API_URL}purchase/charges/update/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      }
    );


    return response;
    /*
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });*/
  }

  deletePurchaseCharge(access_token, id) {
    return axios
      .delete(API_URL + 'purchase/charges/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getDataGrammage(access_token, id) {
    return axios
      .get(API_URL + 'grammage/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postGrammge(access_token, formData) {
    return axios
      .post(API_URL + 'grammage', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updateGrammage(access_token, formData) {
    return axios
      .put(API_URL + 'grammage', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteGrammage(access_token, id) {
    return axios
      .delete(API_URL + 'grammage/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getDataBanners(access_token, id) {
    return axios
      .get(API_URL + 'banners', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postBanner(access_token, formData) {
    return axios
      .post(API_URL + 'banner', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updateBanner(access_token, formData) {
    return axios
      .put(API_URL + 'banner', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteBanner(access_token, id) {
    return axios
      .delete(API_URL + 'banner/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getCategoriesList(access_token) {
    return axios
      .get(API_URL + 'categories-list', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getSettings(access_token) {
    return axios
      .get(API_URL + 'settings', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getWhatsappSendLogSummary(access_token) {
    return axios
      .get(API_URL + 'whatsapp-send-log/summary', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getWhatsappSendLog(access_token, params) {
    return axios
      .get(API_URL + 'whatsapp-send-log', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        params,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updateSettings(access_token, formData) {
    return axios
      .put(API_URL + 'settings', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getPromotions(access_token) {
    return axios
      .get(API_URL + 'promotions', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  async massDebtCharge(access_token) {
    return await axios.get(API_URL + 'massDebtCharge', {
      headers: { Authorization: `Bearer ${access_token}` },
    });
  }

  async getCharges(access_token) {
    return await axios
      .get(API_URL + 'purchase/get/charges', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
  }

  async getAllChargesAudit(access_token, params = {}) {
    const query = new URLSearchParams();
    if (params.state)     query.set('state',     params.state);
    if (params.date_from) query.set('date_from', params.date_from);
    if (params.date_to)   query.set('date_to',   params.date_to);
    if (params.search)    query.set('search',    params.search);
    return await axios.get(API_URL + `purchase/charges/audit?${query.toString()}`, {
      headers: { Authorization: `Bearer ${access_token}` },
    });
  }

  async cancelPurchaseCharge(access_token, id, reason) {
    const response = await axios.post(
      API_URL + `purchase/charges/${id}/cancel`,
      { reason },
      { headers: { Authorization: `Bearer ${access_token}` } }
    );
    return response.data;
  }

  async getUserPendingDebts(access_token, id_user) {
    return await axios
      .get(API_URL + `purchase/user-debts/${id_user}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
  }

  getPresentaciones(access_token) {
    return axios
      .get(API_URL + 'products_child', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postPromocion(access_token, data) {
    return axios
      .post(API_URL + 'promotions', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getPromotionDetails(access_token, id) {
    return axios
      .get(API_URL + 'promotions/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  updatePromotion(access_token, data) {
    return axios
      .put(API_URL + 'promotions', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deletePromotion(access_token, id) {
    return axios
      .delete(API_URL + 'promotions/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Customer Clusters Methods
  getCustomerClusters(access_token) {
    return axios
      .get(API_URL + 'customer-clusters', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getCustomerClusterDetails(access_token, id) {
    return axios
      .get(API_URL + 'customer-clusters/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postCustomerCluster(access_token, data) {
    return axios
      .post(API_URL + 'customer-clusters', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putCustomerCluster(access_token, data) {
    return axios
      .put(API_URL + 'customer-clusters', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteCustomerCluster(access_token, id) {
    return axios
      .delete(API_URL + 'customer-clusters/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Customer Cluster Members Methods
  getUserCluster(access_token, id_user) {
    return axios
      .get(API_URL + 'users/' + id_user + '/cluster', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getClusterUsers(access_token, id_cluster) {
    return axios
      .get(API_URL + 'customer-clusters/' + id_cluster + '/users', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  assignUserToCluster(access_token, data) {
    return axios
      .post(API_URL + 'users/assign-cluster', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  removeUserFromCluster(access_token, id_user) {
    return axios
      .delete(API_URL + 'users/' + id_user + '/cluster', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // ==================== WHATSAPP CAMPAIGNS ====================

  // Lista de campañas de WhatsApp
  getWhatsappCampaigns(access_token) {
    return axios
      .get(API_URL + 'whatsapp-campaigns', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Detalles de una campaña de WhatsApp
  getWhatsappCampaignDetails(access_token, id) {
    return axios
      .get(API_URL + 'whatsapp-campaigns/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Crear campaña de WhatsApp
  postWhatsappCampaign(access_token, data) {
    return axios
      .post(API_URL + 'whatsapp-campaigns', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Actualizar campaña de WhatsApp
  putWhatsappCampaign(access_token, data) {
    return axios
      .put(API_URL + 'whatsapp-campaigns', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Eliminar campaña de WhatsApp
  deleteWhatsappCampaign(access_token, id) {
    return axios
      .delete(API_URL + 'whatsapp-campaigns/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // ==================== CAMPAIGN PROMOTIONS ====================

  // Lista de promociones de una campaña
  getCampaignPromotions(access_token, id_campaign) {
    return axios
      .get(API_URL + 'whatsapp-campaigns/' + id_campaign + '/promotions', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Detalles de una promoción de campaña
  getCampaignPromotionDetails(access_token, id) {
    return axios
      .get(API_URL + 'campaign-promotions/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Crear promoción de campaña
  postCampaignPromotion(access_token, data) {
    return axios
      .post(API_URL + 'campaign-promotions', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Actualizar promoción de campaña
  putCampaignPromotion(access_token, data) {
    return axios
      .put(API_URL + 'campaign-promotions', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Eliminar promoción de campaña
  deleteCampaignPromotion(access_token, id) {
    return axios
      .delete(API_URL + 'campaign-promotions/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // ============================================
  // PRODUCT COLLECTIONS METHODS
  // ============================================

  getProductCollections(access_token) {
    return axios
      .get(API_URL + 'product-collections', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getProductCollectionDetails(access_token, id) {
    return axios
      .get(API_URL + 'product-collections/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postProductCollection(access_token, data) {
    return axios
      .post(API_URL + 'product-collections', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putProductCollection(access_token, data) {
    return axios
      .put(API_URL + 'product-collections', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteProductCollection(access_token, id) {
    return axios
      .delete(API_URL + 'product-collections/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getCollectionProducts(access_token, id_collection) {
    return axios
      .get(API_URL + 'product-collections/' + id_collection + '/products', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  assignProductToCollection(access_token, data) {
    return axios
      .post(API_URL + 'collection-products', data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  removeProductFromCollection(access_token, id) {
    return axios
      .delete(API_URL + 'collection-products/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteAddress(access_token, id) {
    return axios
      .delete(API_URL + 'address/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Trae los meses y años de ventas
  getDataReportsMonthsAndYears(access_token) {
    return axios
      .get(API_URL + 'DataReportsMonthsAndYears', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }


  getReportCashUser(access_token, formData) {
    return axios
      .post(API_URL + 'allinternalaccounts', formData,  {
        headers: {
          Authorization: `Bearer ${access_token}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Trae los meses y años de ventas
  getDataReportsMonthsAndYearsPending(access_token) {
    return axios
      .get(API_URL + 'DataReportsMonthsAndYearsPending', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getOrdersReportFilter(access_token, month, year) {
    return axios
      .get(API_URL + `purchaseReportPending/${month}/${year}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Reporte de ventas por rango de fechas -- usado por el filtro "Por
  // rango de fechas" de Reporte de Ventas.
  getOrdersReportRange(access_token, from, to) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const qs = params.toString();
    return axios
      .get(API_URL + 'purchaseReportRange' + (qs ? `?${qs}` : ''), {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getOrdersFilter(access_token, month, year) {
    return axios
      .get(API_URL + `purchasePending/${month}/${year}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Trae los meses y años de ventas - Sku
  getDataReportsMonthsAndYearsSku(access_token) {
    return axios
      .get(API_URL + 'DataReportsMonthsAndYearsSku', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Traer los productos por sku por meses
  getProductsForMonthFilter(access_token, month, year) {
    return axios
      .get(API_URL + `productsForMonth/${month}/${year}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Trae los Usuarios
  getDataCustomers(access_token) {
    return axios
      .get(API_URL + `DataCustomers`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Clientes que hicieron al menos una compra -- usado en el autocomplete
  // de /sku-monthly-sale-customer en vez de todos los usuarios registrados.
  getCustomersWithPurchases(access_token) {
    return axios
      .get(API_URL + `customersWithPurchases`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

   // Traer los productos por sku por meses y cliente
   getProductsForMonthCustomerFilter(access_token, month, year, customer) {
    return axios
      .get(API_URL + `productsForMonthCustomer/${month}/${year}/${customer}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Productos comprados por un cliente, con rango de fechas opcional -- sin
  // él trae todo el historial del cliente.
  getProductsForCustomer(access_token, customer, from, to) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const qs = params.toString();
    return axios
      .get(API_URL + `productsForCustomer/${customer}` + (qs ? `?${qs}` : ''), {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Trae los Productos
  getDataProducts(access_token) {
    return axios
      .get(API_URL + `DataProducts`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Traer los productos por sku por meses y cliente
  getProductsForMonthCustomer(access_token, month, year, customer) {
    return axios
      .get(API_URL + `getProductsForMonthCustomer/${month}/${year}/${customer}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Clientes que compraron un SKU en un rango de fechas (unidades, precio, total)
  getCustomersForProductRange(access_token, sku, from, to) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const qs = params.toString();
    return axios
      .get(API_URL + `customersForProductRange/${sku}` + (qs ? `?${qs}` : ''), {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

   // Traer los reportes de productos vendidos por sku
   getProductsReport(access_token, month, year) {
    return axios
      .get(API_URL + `listReportProductsForMonth/${month}/${year}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Trae los clientes por meses y años - Sku
  getDataReportsCustomersMonthsAndYears(access_token) {
    return axios
      .get(API_URL + 'DataReportsCustomersMonthsAndYears', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Traer los reportes de productos vendidos por sku
  getCustomersReport(access_token, month, year) {
    return axios
      .get(API_URL + `listReportCustomersForMonth/${month}/${year}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Cohortes de clientes (fila=cohorte por mes de 1ra compra, columna=mes
  // calendario, celda=monto vendido) -- todo el histórico, sin mes/año
  getCustomerCohorts(access_token) {
    return axios
      .get(API_URL + `customerCohorts`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Listado de productos vendidos filtrado por rango de fechas (por defecto: hoy)
  getProductsSold(access_token, from, to) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const qs = params.toString();
    return axios
      .get(API_URL + 'products-sold' + (qs ? `?${qs}` : ''), {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // Traer los reportes de productos vendidos por sku
  alertsCount(access_token) {
    return axios
      .get(API_URL + `alerts`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getChangeLog(access_token) {
    return axios
      .get(API_URL + 'changelog', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getCodes(access_token) {
    return axios
      .get(API_URL + 'codes ', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putCode(access_token, formData) {
    return axios
      .put(API_URL + 'codes', formData,{
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postCodes(access_token, formData) {
    return axios
      .post(API_URL + 'codes', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getCodeDetails(access_token, id) {
    return axios
      .get(API_URL + 'codes/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteCode(access_token, id) {
    return axios
      .delete(API_URL + 'codes/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }
  getSelling(access_token) {
    return axios
      .get(API_URL + 'selling', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  putSelling(access_token, formData) {
    return axios
      .put(API_URL + 'selling', formData,{
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': `application/json`,
          cache: false,
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  postSelling(access_token, formData) {
    return axios
      .post(API_URL + 'selling', formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          cache: false, 
          contentType: false,
          processData: false,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getSellingDetails(access_token, id) {
    return axios
      .get(API_URL + 'selling/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getSellingPreviewAll(access_token) {
    return axios
      .get(API_URL + 'selling/preview/all', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  deleteSelling(access_token, id) {
    return axios
      .delete(API_URL + 'selling/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  } 

  getAudit(access_token, id) {
    return axios
    .get(API_URL + 'codes-audit/' + id, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  //abandoned-cart
  getAbandonedCart(access_token) {
    return axios
      .get(API_URL + 'abandoned-cart', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getNonBuyerUsers(access_token) {
    return axios
      .get(API_URL + 'non-buyer-users', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getLowPurchaseHistoryCustomers(access_token) {
    return axios
      .get(API_URL + 'low-purchase-history-customers', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }


  getInactiveCustomers(access_token) {
    return axios
      .get(API_URL + 'inactive-customers', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getBlockUserForMultipleIPs(access_token) {
    return axios
      .get(API_URL + 'block-users', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getBlockUserForSimultaneousIPs(access_token) {
    return axios
      .get(API_URL + 'block-users-simultaneous-ips', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  getOnlineUsers(access_token) {
    return axios
      .get(API_URL + 'online-users', {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
      });
  }

  // ==================== BULK WHATSAPP CAMPAIGNS ====================

  getBulkWhatsappCampaigns(access_token) {
    return axios
      .get(API_URL + 'bulk-whatsapp-campaigns', {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
  }

  getBulkWhatsappCampaignById(access_token, id) {
    return axios
      .get(API_URL + 'bulk-whatsapp-campaigns/' + id, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
  }

  postBulkWhatsappCampaign(access_token, data) {
    return axios
      .post(API_URL + 'bulk-whatsapp-campaigns', data, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch((error) => { throw error; });
  }

  putBulkWhatsappCampaign(access_token, data) {
    return axios
      .put(API_URL + 'bulk-whatsapp-campaigns', data, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch((error) => { throw error; });
  }

  deleteBulkWhatsappCampaign(access_token, id) {
    return axios
      .delete(API_URL + 'bulk-whatsapp-campaigns/' + id, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch((error) => { throw error; });
  }

  startBulkWhatsappCampaign(access_token, id) {
    return axios
      .post(API_URL + 'bulk-whatsapp-campaigns/' + id + '/start', {}, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch((error) => { throw error; });
  }

  prepareBulkWhatsappCampaign(access_token, id) {
    return axios
      .post(API_URL + 'bulk-whatsapp-campaigns/' + id + '/prepare', {}, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch((error) => { throw error; });
  }

  sendBulkWhatsappCampaignBatch(access_token, id, limit) {
    return axios
      .post(API_URL + 'bulk-whatsapp-campaigns/' + id + '/send-batch?limit=' + (limit || 50), {}, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch((error) => { throw error; });
  }

  getBulkWhatsappCampaignStats(access_token, id) {
    return axios
      .get(API_URL + 'bulk-whatsapp-campaigns/' + id + '/stats', {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
  }

  getCustomerProfile(access_token, id) {
    return axios
      .get(API_URL + 'customer-profile/' + id, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

  getCustomerPurchaseStats(access_token, id) {
    return axios
      .get(API_URL + 'customer-profile/' + id + '/purchase-stats', {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

  getCustomerPurchases(access_token, id, limit = 50, offset = 0) {
    return axios
      .get(API_URL + 'customer-profile/' + id + '/purchases?limit=' + limit + '&offset=' + offset, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

  getCustomerAddresses(access_token, id) {
    return axios
      .get(API_URL + 'customer-profile/' + id + '/addresses', {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

  getCustomerClustersAndCampaigns(access_token, id) {
    return axios
      .get(API_URL + 'customer-profile/' + id + '/clusters-and-campaigns', {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

  getCustomerPurchaseDetail(access_token, userId, purchaseId) {
    return axios
      .get(API_URL + 'customer-profile/' + userId + '/purchases/' + purchaseId, {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

  getCustomerPayments(access_token, userId) {
    return axios
      .get(API_URL + 'customer-profile/' + userId + '/payments', {
        headers: { Authorization: `Bearer ${access_token}` },
      })
      .then((response) => response.data)
      .catch(() => null);
  }

}

export default new ApiService();
